import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/Accordion";

import AdoptStages from "../components/adopt/AdoptStages";
import Button from "../components/Button";
import PetHeader from "../components/PetHeader";
import StickyScrollWrapper from "../components/StickyScrollWrapper";
import { useUserContext } from "../context/User";
import { createAdoption, getAdoptionForPet, getPetByID } from "../services/api";
import { adoptionKey, removeFromStorage } from "../services/storage";

const staticUrl: string = process.env.STATIC_URL;

export default function Adopt() {
  const [loading, setLoading] = useState(true);
  const [pet, setPet] = useState({});
  const [adoption, setAdoption] = useState<object | null>(null);
  const navigate = useNavigate();
  const { user } = useUserContext();
  const { id } = useParams<{
    id: string;
  }>();
  const containerRef = useRef(null);

  useEffect(() => {
    void getPetByID(id)
      .then((data) => setPet(data))
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (!pet || !pet.id || !user.accessToken) return;

    const initAdoption = async () => {
      let adoptionObj = await getAdoptionForPet(user.accessToken, pet.id);
      if (!adoptionObj) {
        adoptionObj = await createAdoption(user.accessToken, pet.id, {});
      }
      setAdoption(adoptionObj ?? null);
    };

    void initAdoption();
  }, [pet, user]);

  const resetAdoptionData = async () => {
    // removeFromStorage(`${adoptionKey}-${pet.id}`);
    await createAdoption(user.accessToken, pet.id, {});
    window.location.reload();
  };

  if (!pet || loading) {
    return null;
  }

  return (
    <>
      <div className="container mx-auto mb-10 px-5">
        <div className="mb-6 text-theme-grey-7">
          <Link to="/">Home</Link> / <span className="text-theme-grey-11">{pet.name}</span>
        </div>
        <PetHeader pet={pet} showMore={true}>
          <div className="flex gap-5">
            <Button title="Reset" theme="transparent" size="medium" onClick={resetAdoptionData} />
            <Button title="Cancel" theme="secondary" size="medium" onClick={() => navigate(-1)} />
          </div>
        </PetHeader>
      </div>

      <div className="container mx-auto px-5">
        <div className="mb-10">
          <AdoptStages pet={pet} adoption={adoption} />
        </div>
      </div>
    </>
  );
}
